import { mapGetters, mapMutations } from 'vuex';
import BundleSelector from './partials/bundle-selector';
import { scrollToFirstError } from '@jgile/laravel-vue/resources/js/util';

Vue.component('update-bundle', {
    props: {
        attributes: {
            required: true,
        },
    },
    components: { BundleSelector },
    data() {
        return {
            loading: false,
            asset: new SparkForm({
                id: null,
                name: '',
                description: '',
                lead_time_id: null,
                asset_type: 'simple',
                status: 0,
                asset_images: [],
                base_units_available: null,
                base_units_posted: null,
                online_price: null,
                bundle_only: false,
                purchase_total_max_units: null,
                purchase_max_units: null,
                purchase_min_units: null,
                purchase_min_games: null,
                demographics_metrics: null,
                start_date: null,
                end_date: null,
                products: null,
                bundle_assets: [],
                industries: [],
            }),
            changed: false,
            datePickerConfig: {
                mode: 'range',
                minDate: new Date(),
            },
        };
    },
    created() {
        const _this = this;
        this.asset.id = this.attributes.id;
        this.asset.name = this.attributes.name;
        this.asset.status = this.attributes.status;
        this.asset.asset_type = this.attributes.asset_type;
        this.asset.bundle_assets = this.attributes.bundle_assets;
        this.asset.start_date = this.attributes.start_date;
        this.asset.end_date = this.attributes.end_date;
        this.asset.create_type = _.get(this, 'create_type', 0);

        //
        // Get asset attributes
        //
        let assetAttributes = _.merge(this.attributes, {
            industries: _.map(this.attributes.industries, (industry) => industry.id),
        });

        //
        // Get bundled assets
        //
        this.setAssets(_.get(assetAttributes, 'bundle_assets'));
        this.setInitialAsset(assetAttributes);

        //
        // Get only the asset attributes I need, or default value.
        //
        _.each(this.asset, (value, attribute) => {
            _.set(_this.asset, attribute, _.get(_this.attributes, attribute, value));
        });

        this.setCartItems(
            _.map(this.attributes.bundle_assets, (item) => {
                return item.id;
            }),
        );

        this.$watch(
            'asset',
            () => {
                this.changed = true;
            },
            { deep: true },
        );
    },

    /*
    |--------------------------------------------------------------------------
    | Computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters('bundle', ['bundleAssets', 'bundleAssetsCount', 'suggestedPrice']),
        date: {
            get() {
                return {
                    start: this.asset.start_date,
                    end: this.asset.end_date,
                };
            },
            set(newVal) {
                this.asset.start_date = newVal.start;
                this.asset.end_date = newVal.end;
            },
        },
    },

    /*
    |--------------------------------------------------------------------------
    | Methods
    |--------------------------------------------------------------------------
    */
    methods: {
        ...mapMutations('bundle', ['addAsset', 'setAssets', 'removeAsset', 'setCartItems', 'setInitialAsset']),

        /*
        |--------------------------------------------------------------------------
        | Saving Methods
        |--------------------------------------------------------------------------
        */
        saveAndNext() {
            if (this.changed) {
                this.save().then((response) => {
                    window.location = `/team/bundles/${response.data.id}/details`;
                });
            } else {
                window.location = `/team/bundles/${this.asset.id}/details`;
            }
        },
        saveAndStay() {
            const _this = this;
            this.save();
        },
        save() {
            this.asset.status = 0;
            this.asset.bundle_assets = _.map(this.bundleAssets, function(o) {
                return { asset_id: o.id, units: _.get(o, 'pivot.units', 1) };
            });

            return Spark.put(`/api/team/assets/${this.attributes.id}`, this.asset).catch(() => {
                scrollToFirstError();
            });
        },
    },
});
